import { useEffect, useState } from 'react';
const useFaq = ({ items }) => {
    const [isLoaded, setLoaded] = useState(false);
    useEffect(() => {
        if (!isLoaded) {
            setLoaded(true);
            return;
        }
        const script = `
      <script type="application/ld+json" id="losse-schema-faq">
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [${items.map((item) => `
            {
              "@type": "Question",
              "name": "${item.question}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${item.answer}"
              }
            }
          `)}]
        }
      </script>
    `;
        document.head.insertAdjacentHTML('beforeend', script);
        return () => {
            const script = document.getElementById('losse-schema-faq');
            if (script)
                script.remove();
        };
    }, [isLoaded]);
};
export default useFaq;
